import { AnyAction } from 'redux'
import { IPaymentState } from '~/shared/store/types'

import {
  RESET_3D_SECURE_IFRAME_URL,
  SET_3D_SECURE_IFRAME_URL,
  SET_IS_ALREADY_BOUGHT,
  SET_IS_DIRECT_STRIPE_PAYMENT_ENABLED,
  SET_IS_FIRST_PAYMENT_RETRY_PASSED,
  SET_IS_FORCE_3DS,
  SET_IS_PRIMER_RETRY_PROCESSING,
  SET_IS_SUBSCRIPTION_PURCHASE_INITIATED,
  SET_PAYMENT_CONFIG,
  SET_PAYMENT_PROCESSOR_NAMES,
  SET_PRIMER_CLIENT_TOKEN,
  SET_STRIPE_CLIENT_SECRET,
  SET_STRIPE_QUICK_PAY_CHECKED,
  SET_STRIPE_QUICK_PAY_METHOD,
} from './actionTypes'

const initState: IPaymentState = {
  primer: {
    clientToken: '',
    isCreditCardAvailable: false,
    isRetryProcessing: false,
    isFirstPaymentRetryPassed: false,
    applePayEnabled: false,
    googlePayEnabled: false,
    isForce3DS: false,
    processorName: '',
    applePayProcessorName: '',
    googlePayProcessorName: '',
    paypalProcessorName: '',
  },
  stripe: {
    accountId: '',
    accountName: '',
    publicKey: '',
    clientSecret: '',
    threeDSecureIframeURL: '',
    quickPayMethod: null,
    isQuickPayChecked: false,
  },
  isSubscriptionPurchaseInitiated: false,
  isAlreadyBought: false,
  isDirectStripePaymentEnabled: false,
}

export function paymentReducer(
  state: IPaymentState = initState,
  { type, payload = null }: AnyAction,
): IPaymentState {
  switch (type) {
    case SET_IS_PRIMER_RETRY_PROCESSING: {
      return {
        ...state,
        primer: {
          ...state.primer,
          isRetryProcessing: payload,
        },
      }
    }
    case SET_IS_FIRST_PAYMENT_RETRY_PASSED: {
      return {
        ...state,
        primer: {
          ...state.primer,
          isFirstPaymentRetryPassed: payload,
        },
      }
    }
    case SET_PRIMER_CLIENT_TOKEN: {
      return {
        ...state,
        primer: {
          ...state.primer,
          clientToken: payload,
        },
      }
    }
    case SET_3D_SECURE_IFRAME_URL: {
      return {
        ...state,
        stripe: {
          ...state.stripe,
          threeDSecureIframeURL: payload,
        },
      }
    }
    case RESET_3D_SECURE_IFRAME_URL: {
      return {
        ...state,
        stripe: {
          ...state.stripe,
          threeDSecureIframeURL: '',
        },
      }
    }
    case SET_STRIPE_CLIENT_SECRET: {
      return {
        ...state,
        stripe: {
          ...state.stripe,
          clientSecret: payload,
        },
      }
    }
    case SET_STRIPE_QUICK_PAY_METHOD: {
      return {
        ...state,
        stripe: {
          ...state.stripe,
          quickPayMethod: payload,
        },
      }
    }
    case SET_STRIPE_QUICK_PAY_CHECKED: {
      return {
        ...state,
        stripe: {
          ...state.stripe,
          isQuickPayChecked: true,
        },
      }
    }
    case SET_PAYMENT_CONFIG: {
      return {
        ...state,
        primer: {
          ...state.primer,
          isCreditCardAvailable: payload.primer.enabled,
          applePayEnabled: payload.primer.applePayEnabled,
          googlePayEnabled: payload.primer.googlePayEnabled,
        },
        stripe: {
          ...state.stripe,
          accountId: payload.stripe.accountId,
          accountName: payload.stripe.accountName,
          publicKey: payload.stripe.publicKey,
        },
      }
    }
    case SET_IS_SUBSCRIPTION_PURCHASE_INITIATED: {
      return {
        ...state,
        isSubscriptionPurchaseInitiated: state.isSubscriptionPurchaseInitiated,
      }
    }
    case SET_IS_ALREADY_BOUGHT: {
      return {
        ...state,
        isAlreadyBought: payload,
      }
    }
    case SET_IS_FORCE_3DS: {
      return {
        ...state,
        primer: {
          ...state.primer,
          isForce3DS: payload,
        },
      }
    }
    case SET_PAYMENT_PROCESSOR_NAMES: {
      return {
        ...state,
        primer: {
          ...state.primer,
          processorName: payload.processorName,
          applePayProcessorName: payload.applePayProcessorName,
          googlePayProcessorName: payload.googlePayProcessorName,
          paypalProcessorName: payload.paypalProcessorName,
        },
      }
    }
    case SET_IS_DIRECT_STRIPE_PAYMENT_ENABLED: {
      return {
        ...state,
        isDirectStripePaymentEnabled: payload,
      }
    }
    default:
      return state
  }
}
